function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 12.445a3.552 3.552 0 006.063 2.515l3.774-3.774a3.57 3.57 0 00.327-4.646.887.887 0 00-1.59.412.888.888 0 00.171.658 1.776 1.776 0 01-.164 2.32l-3.774 3.774a1.778 1.778 0 01-2.511-2.518l1.662-1.66a.888.888 0 10-1.256-1.257l-1.66 1.663A3.52 3.52 0 000 12.445z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.073 6.433a.888.888 0 101.257 1.255l1.66-1.66A3.552 3.552 0 009.97 1.002L6.195 4.777a3.567 3.567 0 00-.322 4.633.888.888 0 001.418-1.07 1.776 1.776 0 01.165-2.322l3.774-3.774a1.78 1.78 0 012.506 2.527l-1.663 1.662z",
  fill: "#fff"
})));